import React from 'react';
import { ClipboardList, Home, Check, FileText, Image, FileBox, Users, Save } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { Button } from '../../ui/Button';

type TabId = 'general' | 'details' | 'criteria' | 'description' | 'photos' | 'documents' | 'matching';

interface Tab {
  id: TabId;
  label: string;
  icon: React.ElementType;
}

const tabs: Tab[] = [
  { id: 'general', label: 'Informations', icon: ClipboardList },
  { id: 'details', label: 'Descriptif', icon: Home },
  { id: 'criteria', label: 'Critères', icon: Check },
  { id: 'description', label: 'Texte Annonce', icon: FileText },
  { id: 'photos', label: 'Photos', icon: Image },
  { id: 'documents', label: 'Documents', icon: FileBox },
  { id: 'matching', label: 'Rapprochement', icon: Users },
];

interface PropertyFormTabsProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
  onSave?: () => void;
  isSubmitting?: boolean;
}

export const PropertyFormTabs: React.FC<PropertyFormTabsProps> = ({
  activeTab,
  onTabChange,
  onSave,
  isSubmitting = false,
}) => {
  return (
    <div className="border-b border-gray-200 dark:border-gray-700">
      <nav className="flex items-center justify-between px-4 sm:px-6" aria-label="Tabs">
        <div className="flex space-x-3 sm:space-x-8 overflow-x-auto scrollbar-hide overscroll-x-contain flex-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={cn(
                'group inline-flex items-center gap-2 border-b-2 px-2 sm:px-1 py-4 text-sm sm:text-sm font-medium whitespace-nowrap touch-manipulation',
                activeTab === tab.id
                  ? 'border-primary-500 text-primary-500'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
              )}
            >
              <Icon className="h-5 w-5 shrink-0" />
              {tab.label}
            </button>
          );
        })}
        </div>
        
        {/* Bouton Enregistrer permanent */}
        {onSave && (
          <div className="py-2 ml-2 sm:ml-0 shrink-0">
            <Button
              onClick={onSave}
              disabled={isSubmitting}
              size="icon"
              className="h-11 w-11 sm:h-10 sm:w-10"
              title={isSubmitting ? 'Enregistrement...' : 'Enregistrer le bien'}
            >
              <Save className="h-5 w-5" />
            </Button>
          </div>
        )}
      </nav>
    </div>
  );
};